import { render } from "./hsec1.vue?vue&type=template&id=607c0c76&scoped=true"
import script from "./hsec1.vue?vue&type=script&lang=js"
export * from "./hsec1.vue?vue&type=script&lang=js"

import "./hsec1.vue?vue&type=style&index=0&id=607c0c76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607c0c76"]])

export default __exports__